import React from "react";

export function ExternalLink({href, children, ...props}) {
    return <a href={href} target='_blank' rel='noreferrer' {...props}>{children}</a>
}
